import React, { useEffect, useState } from 'react';
import { Helmet } from 'react-helmet-async';
import { FaEnvelope, FaMapMarkerAlt } from 'react-icons/fa';
import ContactPage from '../../../components/Global/BannerCard/DynamicHeader/ContactPage1';
import OurLocations from './OurLocations';
import CustomerContactForm from './CustomerContactForm';

const ContactUs = () => {
  const [seo, setSeo] = useState(null);

  const canonicalUrl = `${process.env.REACT_APP_BASE_URL}/contact`;
  const isDevelopment = process.env.NODE_ENV === 'development';

  useEffect(() => {
    // Set SEO metadata immediately without artificial delay
    const metadata = {
      title: 'Adithya Infinity',
      description:
        'Looking to apply for IT or Non-IT jobs? Contact V Adithya Infinity Pvt Ltd for career opportunities, recruitment support, staffing solutions, and personalized job consultation services across India.',
      keywords:
        'contact IT jobs India, Non-IT careers, V Adithya Infinity, job consultancy, job application help, recruitment agency, career support, staffing services, job openings Hyderabad, Bangalore jobs, Chennai IT jobs, Mumbai Non-IT careers, resume support, apply for job, tech jobs India, fresher job contact, experienced job opportunities',
      canonical: canonicalUrl,
      image: 'https://www.adithyainfinity.com/assets/images/share-banner.jpg',
    };
    setSeo(metadata);
  }, [canonicalUrl]);

  return (
    <>
      {seo && (
        <Helmet>
          <title>{seo.title}</title>
          <meta name="description" content={seo.description} />
          <meta name="keywords" content={seo.keywords} />
          {isDevelopment ? (
            <meta name="robots" content="noindex, nofollow" />
          ) : (
            <link rel="canonical" href={seo.canonical} />
          )}
          <meta property="og:title" content="Contact Us | V Adithya Infinity Pvt Ltd" />
          <meta
            property="og:description"
            content="Get in touch with V Adithya Infinity Pvt Ltd for IT & Non-IT job applications, resume help, recruitment services, and staffing solutions across major cities in India."
          />
          <meta property="og:url" content={seo.canonical} />
          <meta property="og:type" content="website" />
          <meta property="og:image" content={seo.image} />

          <meta name="twitter:card" content="summary_large_image" />
          <meta name="twitter:title" content="Contact V Adithya Infinity Pvt Ltd | Apply for Jobs in IT & Non-IT" />
          <meta
            name="twitter:description"
            content="Connect with our team to apply for IT and Non-IT jobs. We offer personalized career support, job listings, and recruitment services across India."
          />
          <meta name="twitter:image" content={seo.image} />
        </Helmet>
      )}

      <div>
        <ContactPage
          title=""
          backgroundImage="https://static.vecteezy.com/system/resources/previews/005/263/636/non_2x/contact-us-concept-icons-such-as-mobile-phone-e-mail-address-chat-global-communication-on-dark-blue-background-for-presentation-web-banner-article-business-and-network-connection-and-company-free-vector.jpg"
          highlightWord=""
        />

        {/* Tailwind-Based Contact Info Section */}

        <section className="w-full bg-gray-50 py-12">
  <div className="max-w-6xl mx-auto px-6 grid grid-cols-1 md:grid-cols-3 gap-10">

    {/* Email Card */}
    <div className="group bg-gray-100 border border-transparent hover:border-blue-500 hover:bg-white transition-all duration-300 rounded-xl shadow-sm hover:shadow-md p-8 flex flex-col items-center text-center cursor-pointer">
      <div className="bg-blue-100 p-4 rounded-full mb-4 transition-all duration-300 group-hover:scale-110">
        <FaEnvelope size={30} className="text-blue-600" />
      </div>
      <h3 className="text-lg font-semibold mb-1 text-gray-800">Email Us</h3>
      <a
        href="mailto:contact@adithyainfinity.com"
        className="text-blue-600 hover:underline text-sm break-all"
      >
        contact@adithyainfinity.com
      </a>
    </div>

    {/* Hyderabad Address Card */}
    <div className="group bg-gray-100 border border-transparent hover:border-green-500 hover:bg-white transition-all duration-300 rounded-xl shadow-sm hover:shadow-md p-8 flex flex-col items-center text-center cursor-pointer">
      <div className="bg-green-100 p-4 rounded-full mb-4 transition-all duration-300 group-hover:scale-110">
        <FaMapMarkerAlt size={30} className="text-green-600" />
      </div>
      <h3 className="text-lg font-semibold mb-1 text-gray-800">Visit Us - Hyderabad</h3>
      <p className="text-sm text-gray-700 leading-relaxed">
        No.# 610/B, 6th floor,<br />
        Sandhya Techno-1 X-road, Radha Nagar,<br />
        Khajaguda, Rai Durg,<br />
        Hyderabad, Telangana - 500081
      </p>
    </div>

    {/* Vizag Address Card */}
    <div className="group bg-gray-100 border border-transparent hover:border-green-500 hover:bg-white transition-all duration-300 rounded-xl shadow-sm hover:shadow-md p-8 flex flex-col items-center text-center cursor-pointer">
      <div className="bg-green-100 p-4 rounded-full mb-4 transition-all duration-300 group-hover:scale-110">
        <FaMapMarkerAlt size={30} className="text-green-600" />
      </div>
      <h3 className="text-lg font-semibold mb-1 text-gray-800">Vizag</h3>
      <p className="text-sm text-gray-700 leading-relaxed">
        APIS, IT Incubation Centre,<br />
        Hill No - 03 Sunrise, Road,<br />
        Startup Village, Pedda Rushikonda,<br />
        Madhurawada, Visakhapatnam,<br />
        Andhra Pradesh 530045
      </p>
    </div>

  </div>
</section>

        <CustomerContactForm />
        <OurLocations />
      </div>
    </>
  );
};

export default ContactUs;
